<template>
    <div v-if="hasRecallError" class="w-full p-5 rounded-[5px] border-2 border-[#DC3545] bg-[#DC3545]/10">
        <p class="text-base font-bold text-darkGrey mb-2.5">We couldn't find your details.</p>
        <p v-if="quoteRecallErrors.reference" class="text-darkGrey text-sm">
            The quote reference entered could not be found. Please check and try again.
        </p>
        <p v-if="quoteRecallErrors.name" class="text-darkGrey text-sm">
            The last name entered does not match our records. Please check and try again.
        </p>
        <p v-if="quoteRecallErrors.dob" class="text-darkGrey text-sm">
            The date of birth entered does not match our records. Please check and try again.
        </p>
    </div>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import { computed } from "vue";

const mainStore = useMainStore();

const quoteRecallErrors = computed(() => mainStore.quoteRecallErrors);
const hasRecallError = computed(() => Object.values(quoteRecallErrors.value).some(value => value === true));
</script>
